document.addEventListener("DOMContentLoaded", () => {
  $(document).on('click', '.mat-prep-add-lot', function () {
    const currentRow = $(this).closest('tr')
    const id = currentRow.attr('assembly_id');

    currentRow.find('td:nth-child(5)').append(
      `<input type="text" name="new_record_item[${id}][lot][]" class="form-control mt-1" />`
    );

    currentRow.find('td:nth-child(6)').append(
      `<input type="number" name="new_record_item[${id}][qty][]" class="form-control mt-1" step="any" />`
    );
  });

  $(document).on('click', '#mat-prep-export-init', function () {
    loadModal({
      title: "Export Material Preparation",
      url: "/second_process/material_preparations/export"
    })
  })

  $(document).on('click', '#mat-prep-export-apply', function () {
    const $beg = $('#mat-prep-export-beg-date')
    const $end = $('#mat-prep-export-end-date')

    if (!$beg.val()) { alert("Invalid begin date!") }
    if (!$end.val()) { alert("Invalid end date!") }

    window.open(`/second_process/material_preparations/export.xlsx?begin_date=${$beg.val()}&end_date=${$end.val()}`)
  })
})